import { render } from "./Ipay.vue?vue&type=template&id=c32e3bae"
import script from "./Ipay.vue?vue&type=script&lang=js"
export * from "./Ipay.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__